const STORAGE_KEY = "padpulse_group_filters";

function load(): Record<string, string> {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return {};
}

function save(state: Record<string, string>): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {}
}

export function getGroupFilter(page: string): string {
  const state = load();
  return state[page] ?? "all";
}

export function setGroupFilter(page: string, value: string): void {
  const state = load();
  state[page] = value;
  save(state);
}
